"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScroll = exports.defaultScrollExtraPadding = exports.defaultScrollBehaviour = void 0;
var defaultScrollBehaviour = 'smooth';
exports.defaultScrollBehaviour = defaultScrollBehaviour;
var defaultScrollExtraPadding = 0;
/**
 * Scroll element to a child Button
 * @param scrollRef
 */

exports.defaultScrollExtraPadding = defaultScrollExtraPadding;

var useScroll = function useScroll(scrollRef) {
  return function (childIndex) {
    var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollBehaviour;
    var extraPadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultScrollExtraPadding;

    try {
      if (scrollRef.current) {
        var child = scrollRef.current.children[childIndex];
        var computedStyle = getComputedStyle(scrollRef.current);
        var computedPaddingLeft = computedStyle.paddingLeft || '';
        var paddingLeft = parseFloat(computedPaddingLeft) + extraPadding;
        var left = child.offsetLeft - paddingLeft;
        scrollRef.current.scroll({
          left: left,
          behavior: behavior
        });
      }
      /* eslint-disable no-empty */

    } catch (_unused) {}
  };
};

exports.useScroll = useScroll;